import React from 'react';

class CurrentProblem extends React.Component {
    textLimit = (text) => {
        const limit_to = 450
        if(this.props.limit && text.length >= limit_to) {
            text = text.slice(0, limit_to) + '...';
        }
        return text
    }
    render() {
        const {showMore, problem_text} = this.props;

        let value = ''
        if (this.props.limit && problem_text.length >= 450) {
            value = 'pokaż więcej'
        } else {
            value = ''
        }
        return (
            <div className="top-buffer problem-message">
                <span>{this.textLimit(problem_text)}<span className="text-primary pointer" onClick={showMore}>{value}</span>
                </span>
            </div>
        )
    }
}

export default CurrentProblem;